<section class="key-fact-wrap">
  <div class="wrap-lg">
    <div class="key-fact-inner">
      <!-- <div class="nav-sec">
        <div class="back-nav" (click)="util.route('home')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Key Fact Statement</div>
          <div class="page-info">A two line statement for what does the Key Fact Statement stands for</div>
        </div>
      </div> -->
      <div class="box-wrap">
        <pdf-viewer  [src]="iframeSrc" [original-size]="false" [style.height]="calculateHeight()" (after-load-complete)="onLoadComplete($event)"></pdf-viewer>
        <div class="page-action kfs-document">
          <div class="cus-check">
            <input class="input-check" type="checkbox" id="key_fact_agree" [(ngModel)]="isChecked"/>
            <label for="key_fact_agree">I have gone through the complete key fact statement and acknowledge it</label>
          </div>
          <button class="btn-primary" [disabled]="!isChecked" (click)="confirmKfs()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>
